/**
 * Location Information Collection and Use Consent - English v1
 * 
 * Required for Location-Based Services (LBS) compliance
 */
export const LOCATION_V1_EN = {
    version: "v1",
    effectiveDate: "2026-01-16",
    language: "en",
    title: "Location Information Consent",
    content: `
Location Information Collection and Use Consent

Spot Go ("Service") collects and uses location information in accordance with applicable laws. Please review and agree to the following to use the Service.

1. Location Information Collector

Service Name: Spot Go
Contact: lukep81@painori.com

2. Location Information Collected

• GPS-based real-time location (latitude, longitude)
• WiFi/cell tower-based approximate location
• Location accuracy information

3. Purpose of Location Information Use

• Search for nearby stores and posts
• Display and recommend location-based content
• Auto-fill location when registering stores/posts
• Provide map services (Naver Maps, Leaflet)
• Service usage statistics analysis

4. Retention Period

• Real-time location: Used only during service access, not stored on servers.
• Location-based posts: Location included in posts is retained with the post.
• Account deletion: All location-related data is deleted immediately.

5. Third-Party Disclosure

We do not share location information with third parties in principle.

Exceptions:
• When required by law
• External API calls for map services (Naver, Leaflet)

6. User Rights

• You may withdraw consent for location collection at any time.
• Withdrawal limits access to location-based features.
• Contact: lukep81@painori.com

7. Location Information Officer

Contact: lukep81@painori.com

⚠️ Important Notice

Spot Go is a location-based service. Without location consent, the following core features will be unavailable:

• Searching nearby spots (stores/posts)
• Registering new posts and stores
• Map-based exploration

Upon agreement, your browser will prompt for location permission.
`.trim()
};
